import VersionShape from '../../shapes/product-version';
import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import AgGridReact from '../common/ag-table';
import { classes } from './styles/table';
import ProductIDCellComponent from "../common/product-id-cell";
import { Button } from 'reactstrap';

class VersionsView extends React.Component {

  state = {

  };

  constructor(props) {
    super(props);

    this.state.options = {
      context: {
        componentParent: this
      },
      localeText: {
        noRowsToShow: props.t('versions.emptyMessage')
      },
      frameworkComponents: {
        ProductIDCellComponent
      },
      columnDefs: [
        {
          field: 'version',
          headerName: props.t('versions.versionHeader')
        },
        {
          field: 'timestamp',
          headerName: props.t('versions.timestampHeader')
        },
        {
          field: 'md5',
          headerName: props.t('versions.md5Header')
        },
        {
          field: 'status',
          headerName: props.t('versions.statusHeader')
        }
      ],
      enableFilter: true,
      enableSorting: true
    }
  }

  onDeleteClicked = (event, { data }) => {
    const remove = () => {
      this.gridApi.updateRowData({
        remove: [
          data
        ]
      })
    };

    if (!data.uuid) {
      return remove();
    }

    this.props.onDelete(data, remove);
  };

  onSaveClicked = (event, { data, node }) => {
    const setData = (newData) => {
      node.setData({
        ...newData,
        actions: data.actions
          .filter(action => action !== 'Save')
      });
    };
    this.props.onSave(data, setData);
  };

  onAddEmptyRow = () => {
    if (!this.gridApi) {
      return;
    }
    this.gridApi.updateRowData({
      add: [
        {
          actions: VersionsView.getDefaultActions()
        }
      ]
    })
  };

  render() {
    const { t } = this.props;
    return (
      <React.Fragment>
        <div className={classes.header}>
          <div />
          <h3>{this.props.name || t('versions.header')}</h3>
          <div>
            <Button onClick={this.onAddEmptyRow}>Add</Button>
          </div>
        </div>
        <div
          className={`ag-theme-blue ${classes.table}`}
        >
          <AgGridReact
            name="application-versions"
            {...this.state.options}
            items={this.props.versions}
            identifier="version"
          />
        </div>
      </React.Fragment>
    )
  }

}

VersionsView.propTypes = {
  versions: PropTypes.arrayOf(VersionShape).isRequired
};

export default translate(['product'])(VersionsView);



// WEBPACK FOOTER //
// ./src/views/applications/versions.js